(function() {
    'use strict';

    angular.module('app.servicios', []);
})();
